import { useCallback, useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

export const useAudioFavs = () => {
  const [favs, setFavs] = useState({ sfx: [], music: [] });
  useEffect(() => { api.get("/me/audio-favs").then((r) => setFavs(r.data)).catch(() => {}); }, []);
  const toggleFav = useCallback((kind, id) => {
    setFavs((f) => ({ ...f, [kind]: f[kind].includes(id) ? f[kind].filter((x) => x !== id) : [...f[kind], id] }));
    api.post("/me/audio-favs", { kind, id }).then((r) => setFavs(r.data)).catch(() => {});
  }, []);
  return { favs, toggleFav };
};

export const FavStar = ({ on, onClick, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid} aria-pressed={on}
    className={`px-1.5 py-2 transition-transform active:scale-90 ${on ? "text-[#ffc94d]" : "text-slate-600 hover:text-[#ffc94d]"}`}>
    <Star className={`w-3.5 h-3.5 ${on ? "fill-current drop-shadow-[0_0_6px_rgba(255,201,77,0.7)]" : ""}`} />
  </button>
);
